import React, { Component } from 'react';
import { Slide } from 'react-slideshow-image';
import Swipe from 'react-easy-swipe';
import ReactDOM from "react-dom";
import Lightbox from 'react-image-lightbox';

class Slider extends Component {

    constructor(){
        super();

        this.state = {
            photoLBIndex: 0,
            isLBOpen: false,
        };

        this.handleSwipeLeft = this.handleSwipeLeft.bind(this);
        this.handleSwipeRight = this.handleSwipeRight.bind(this);
    }

    handleSwipeLeft(){
        const node = ReactDOM.findDOMNode(this);
        const navNext = node.querySelector(".nav[data-type='next']");
        navNext.click();
    }

    handleSwipeRight(){
        const node = ReactDOM.findDOMNode(this);
        const navPrev = node.querySelector(".nav[data-type='prev']");
        navPrev.click();
    }
  
    render(){

        const lightBoxImages = this.props.images;

        const slides = this.props.images.map(
            (img)=>{
                return(    
                    <div className="each-slide" key={img}>
                        <div style={{'backgroundImage': 'url("'+img+'")', 'height':this.props.slideHeight, 'width':this.props.slideWidth}} onClick={() => this.setState({ isLBOpen: true })}></div>                                
                    </div>
                )
            }
        );
        return(
            <div>
                <Swipe onSwipeLeft={this.handleSwipeLeft} onSwipeRight={this.handleSwipeRight}>
                    <Slide {...this.props.properties}>
                        {slides}
                    </Slide>
                </Swipe>
                {this.state.isLBOpen ?
                <Lightbox
                    mainSrc={lightBoxImages[this.state.photoLBIndex]}
                    nextSrc={lightBoxImages[(this.state.photoLBIndex + 1) % lightBoxImages.length]}
                    prevSrc={lightBoxImages[(this.state.photoLBIndex + lightBoxImages.length - 1) % lightBoxImages.length]}
                    onCloseRequest={() => this.setState({ isLBOpen: false })}
                    onMovePrevRequest={() =>
                    this.setState({
                        photoLBIndex: (this.state.photoLBIndex + lightBoxImages.length - 1) % lightBoxImages.length,
                    })
                    }
                    onMoveNextRequest={() =>
                    this.setState({
                        photoLBIndex: (this.state.photoLBIndex + 1) % lightBoxImages.length,
                    })
                    }
                />
                : ""}
            </div>
            
            
        )
    }
}

export default Slider;